import React, {Component} from 'react';
import update from 'immutability-helper';
import {InfiniteScroller, ThemeContext, Avatar} from '../';
import {appId} from '../../../store/';
import AblyService from '../../../utils/ably';

export default class PeopleOnline extends Component {
  state = {
    people: [],
  };

  componentDidMount() {
    if (!AblyService.realtime) {
      return;
    }
    const channelName = `app/${appId}`;
    this.channel = AblyService.realtime.channels.get(channelName);
    // ably v2: presence.subscribe(action, listener) returns a Promise (not an
    // unsubscribe function). The listener references are retained on the
    // instance methods, so componentWillUnmount's presence.unsubscribe() (no
    // args) still tears down every listener for this channel.
    this.channel.presence.subscribe('enter', this.onPlayerOnline);
    this.channel.presence.subscribe('leave', this.onPlayerOffline);

    const restChannel = AblyService.rest.channels.get(channelName);
    // ably v2: REST presence.get() returns a Promise resolving to a
    // PaginatedResult (with items/next()/hasNext()), instead of the v1
    // (err, page) callback.
    restChannel.presence.get()
      .then(peoplePage => this.loadPeople(null, peoplePage))
      .catch(err => console.error('Failed to fetch presence:', err));
  }

  componentWillUnmount() {
    if (this.channel) {
      this.channel.presence.unsubscribe();
      this.channel.unsubscribe();
      this.channel = null;
    }
  }

  onPlayerOnline = ({data: player}) => {
    if (this.channel && this.playerIndex(player) === -1) {
      this.setState(
        update(this.state, {people: {$unshift: [player]}})
      );
    }
  };

  onPlayerOffline = ({data: player}) => {
    const playerIndex = this.playerIndex(player);
    if (this.channel && playerIndex !== -1) {
      this.setState(
        update(this.state, {people: {$splice: [[playerIndex, 1]]}})
      );
    }
  };

  playerIndex = player => this.state.people.findIndex(pl => player && pl.id === player.id);

  loadPeople = (err, peoplePage) => {
    if (!this.channel || !peoplePage) {
      return;
    }
    this.peoplePage = peoplePage;
    const newPeople = peoplePage.items.map(item => item.data);
    const people = [...this.state.people];
    newPeople.forEach((player) => {
      if (!people.some(pl => pl.id === player.id)) {
        people.push(player);
      }
    });
    this.setState(
      update(this.state, {people: {$set: people}})
    );
  };

  loadUsers = (page) => {
    if (page > 0 && this.peoplePage) {
      // ably v2: PaginatedResult.next() returns a Promise resolving to the
      // next page, instead of taking an (err, page) callback.
      this.peoplePage.next()
        .then(nextPage => this.loadPeople(null, nextPage))
        .catch(err => console.error('Failed to load next page:', err));
    }
  };

  renderUser = (user) => {
    const {id, firstName, lastName, image} = user;
    const fullName = `${firstName} ${lastName}`;
    return (
      <div className="people-online__item" key={id}>
        <Avatar image={image} fullName={fullName} className="people-online__avatar" iconSize="120" imageWidth={180}/>
      </div>
    );
  };

  renderUsersList = () => this.state.people.map(user => this.renderUser(user));

  render() {
    const hasMore = this.peoplePage && this.peoplePage.hasNext();
    return (
      <ThemeContext.Consumer>
        {(theme) => {
          const styles = {color: theme.primaryColor};
          return (
            <div className="people-online">
              <div className="people-online__title">
                <h4 className="title">People Online</h4>
              </div>
              <div className="people-online__content custom-overflow" style={styles}>
                <InfiniteScroller
                  loadMore={this.loadUsers}
                  hasMore={hasMore}
                >
                  {this.renderUsersList()}
                </InfiniteScroller>
              </div>
            </div>
          );
        }}
      </ThemeContext.Consumer>
    );
  }
}
